import React from 'react'

import Buttons from '../buttons/buttons'
import './user-profile-redirect'

const DialogBox = (props: any) => {
  // eslint-disable-next-line @stylistic/max-len
  const { btn1iconclassNmae, btn2iconclassNmae, handleRouteNo, handleRouteYes, message , primaryText , secondaryText } =
    props
    const handleRef = (ref: HTMLParagraphElement | null) => {
      const messageRef = ref
      if (messageRef) {
        messageRef.focus()
      }
    }
  return (
    <div className='submit-bg pointer-events-none' id='pageoverlay' >
      <div className='redirectcopying update-section' >
        <p
          aria-label={message}
          className='poppins-semibold font-10 title-color3'
          id='displaytext'
          ref={handleRef}
          tabIndex={0}
        >
          {message}
        </p>
        <div className='buttons pointer-events-all'>
          <Buttons
            aria-label={primaryText}
            className='yesbtn btn btn-sm btn-primary whitetext font-11 border-radius ms-auto text-uppercase poppins-semibold'
            icon={btn1iconclassNmae}
            label={primaryText}
            onClick={handleRouteYes}
            size='sm'
          />
          <Buttons
            aria-label={secondaryText}
            className='btn-border1 title-color3 btn-sm font-11 border-radius text-uppercase poppins-semibold whitebg'
            icon={btn2iconclassNmae}
            label={secondaryText}
            onClick={handleRouteNo}
            size='sm'
          />
        </div>
      </div>
    </div>
  )
}

export default DialogBox
